var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-justify mt-4"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-justify mt-4"},[_vm._v(_vm._s(_vm.text1))]),(_vm.numP > 1)?_c('p',{staticClass:"text-justify mt-4"},[_vm._v(_vm._s(_vm.text2))]):_vm._e(),(_vm.numP > 2)?_c('p',{staticClass:"text-justify mt-4"},[_vm._v(_vm._s(_vm.text3))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }